import type { Shipment } from "@freightsimple/generated-dashboard-openapi-client/models/Shipment";

// On an appointment pickup the carrier arranges the pickup time with the
// shipper, so customer-set pickup hours don't apply. The date can still move.
export function changePickupDateIsPickingUpByAppointment(shipment: {
  pickupLocation: Pick<Shipment["pickupLocation"], "accessorials">;
}): boolean {
  return shipment.pickupLocation.accessorials.includes(
    "SCHEDULING_APPOINTMENT_REQUIRED",
  );
}
